// Set header height CSS variable
document.documentElement.style.setProperty('--header-height', document.getElementById('shopify-section-header').offsetHeight + 'px');

// Header Inline Search Predictive Functionality
(function() {
  function initHeaderSearch() {
    var searchInput = document.getElementById('HeaderSearchInput');
    var searchResults = document.getElementById('HeaderSearchResults');
    var searchCancel = document.getElementById('HeaderSearchCancel');
    var searchWrapper = document.querySelector('.Header__SearchWrapper');
    var mobileSearchIcon = document.getElementById('MobileSearchIconBtn');
    
    if (!searchInput || !searchResults || !searchWrapper) return;

    var queryMap = {};
    var lastInputValue = '';
    var isMobileSearchActive = false;
    
    // Function to get scrollbar width
    function getScrollbarWidth() {
      return window.innerWidth - document.documentElement.clientWidth;
    }
    
    // Desktop: No need to lock scroll since search has its own container
    // Just track the state with classes for styling purposes
    function lockBodyScroll() {
      if (window.innerWidth >= 768) {
        document.body.classList.add('search-open');
        document.documentElement.classList.add('search-open');
      }
    }
    
    // Function to unlock body scroll
    function unlockBodyScroll() {
      document.body.classList.remove('search-open');
      document.documentElement.classList.remove('search-open');
    }
    
    // Mobile Search Icon Click Handler (for mobile <768px)
    if (mobileSearchIcon) {
      mobileSearchIcon.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        // Check if we're on mobile (<768px)
        if (window.innerWidth < 768) {
          isMobileSearchActive = !isMobileSearchActive;
          
          if (isMobileSearchActive) {
            // Open mobile search
            searchWrapper.classList.add('mobile-search-active');
            mobileSearchIcon.setAttribute('aria-expanded', 'true');
            
            // Add class to body to push content down
            document.body.classList.add('mobile-search-open');
            
            // Calculate and apply dynamic spacing based on search wrapper height
            setTimeout(function() {
              var searchWrapperHeight = searchWrapper.offsetHeight;
              document.documentElement.style.setProperty('--mobile-search-height', searchWrapperHeight + 'px');
            }, 10);
            
            // Focus on search input after a short delay to ensure it's visible
            setTimeout(function() {
              searchInput.focus();
            }, 100);
          } else {
            // Close mobile search
            resetSearch();
            mobileSearchIcon.setAttribute('aria-expanded', 'false');
          }
        }
      });
    }

    function debounce(func, wait) {
      var timeout;
      return function() {
        var context = this, args = arguments;
        clearTimeout(timeout);
        timeout = setTimeout(function() {
          func.apply(context, args);
        }, wait);
      };
    }

    function resetSearch() {
      searchResults.innerHTML = '';
      searchResults.setAttribute('aria-hidden', 'true');
      searchWrapper.classList.remove('is-active');
      
      // Remove mobile search active class
      searchWrapper.classList.remove('mobile-search-active');
      isMobileSearchActive = false;
      
      // Remove mobile search open class from body
      document.body.classList.remove('mobile-search-open');
      
      // Clear mobile search height variable
      document.documentElement.style.setProperty('--mobile-search-height', '0px');
      
      // Reset mobile search icon state
      if (mobileSearchIcon) {
        mobileSearchIcon.setAttribute('aria-expanded', 'false');
      }
      
      // Remove search-open class from header
      var headerSection = document.querySelector('.shopify-section--header');
      var header = headerSection ? headerSection.querySelector('header') : null;
      if (header) {
        header.classList.remove('Header--search-open');
      }
      
      // Hide overlay
      var searchOverlay = document.getElementById('HeaderSearchOverlay');
      if (searchOverlay) {
        searchOverlay.setAttribute('aria-hidden', 'true');
      }
      
      // Remove overflow hidden from body and padding
      unlockBodyScroll();
      
      // Clear input and hide cancel button
      if (searchInput) {
        searchInput.value = '';
      }
      if (searchCancel) {
        searchCancel.style.display = 'none';
      }
    }

    function updateCancelButton() {
      if (searchCancel && searchInput) {
        if (searchInput.value.trim() !== '') {
          searchCancel.style.display = 'block';
        } else {
          searchCancel.style.display = 'none';
        }
      }
    }

    function renderResults(results, currentQuery, append) {
      if (lastInputValue !== currentQuery || !queryMap[currentQuery]) return;
      
      var parser = new DOMParser();
      var seenUrls = {};
      var combinedCells = [];
      var productCount = 0;
      
      // Extract unique products from all responses
      var initialCount = seenUrls.count || 0;
      results.forEach(function(html, index) {
        if (html && html.trim() !== '') {
          try {
            var doc = parser.parseFromString(html, 'text/html');
            var cells = doc.querySelectorAll('.Grid__Cell');
            
            cells.forEach(function(cell) {
              // Only process if we haven't reached the limit
              if (productCount < 30) {
                // Extract product URL to check for duplicates
                var link = cell.querySelector('a[href*="/products/"]');
                if (link) {
                  var productUrl = link.getAttribute('href').split('?')[0]; // Remove query params
                  
                  if (!seenUrls[productUrl]) {
                    seenUrls[productUrl] = true;
                    combinedCells.push(cell.outerHTML);
                    productCount++;
                  }
                }
              }
            });
          } catch (e) {
            console.error('Error parsing search result ' + index + ':', e);
          }
        }
      });
      seenUrls.count = productCount;
      
      if (combinedCells.length > 0) {
        if (append && searchResults.querySelector('.Grid')) {
          // Append new cells to existing grid
          var existingGrid = searchResults.querySelector('.Grid');
          var tempDiv = document.createElement('div');
          tempDiv.innerHTML = combinedCells.slice(seenUrls.existingCount || 0).join('');
          var newCells = tempDiv.querySelectorAll('.Grid__Cell');
          newCells.forEach(function(cell) {
            existingGrid.appendChild(cell);
          });
        } else {
          // Replace entire content (first time)
          var finalHTML = '<div class="Segment"><div class="Segment__Title Segment__Title--flexed" style="display:none !important;"></div><div class="Segment__Content"><div class="Grid Grid--xl">' + combinedCells.join('') + '</div></div></div>';
          
            // Add search-open class to header to remove transparent styles
            var headerSection = document.querySelector('.shopify-section--header');
            var header = headerSection ? headerSection.querySelector('header') : null;
            if (header) {
              header.classList.add('Header--search-open');
            }
            
            // Desktop: add is-active, Mobile: ensure mobile-search-active is present
            if (window.innerWidth >= 768) {
              searchWrapper.classList.add('is-active');
            } else {
              // Mobile already has mobile-search-active from icon click
              if (!searchWrapper.classList.contains('mobile-search-active')) {
                searchWrapper.classList.add('mobile-search-active');
                isMobileSearchActive = true;
              }
            }
            
            // Wait for next frame and then update height multiple times to ensure layout is complete
            requestAnimationFrame(function() {
              updateHeaderHeight();
              // Update again after a short delay to catch any delayed CSS transitions
              setTimeout(function() {
                updateHeaderHeight();
                searchResults.innerHTML = finalHTML;
                searchResults.setAttribute('aria-hidden', 'false');
                
                // Show overlay only on desktop
                var searchOverlay = document.getElementById('HeaderSearchOverlay');
                if (searchOverlay && window.innerWidth >= 768) {
                  searchOverlay.setAttribute('aria-hidden', 'false');
                  // Position overlay below search results
                  var resultsRect = searchResults.getBoundingClientRect();
                  searchOverlay.style.top = resultsRect.bottom + 'px';
                }
                
                // Update one more time after results are rendered
                setTimeout(function() {
                  updateHeaderHeight();
                  // Update overlay position again after layout settles (desktop only)
                  if (searchOverlay && window.innerWidth >= 768) {
                    var resultsRect = searchResults.getBoundingClientRect();
                    searchOverlay.style.top = resultsRect.bottom + 'px';
                  }
                }, 0);
              }, 10);
              
              // Add overflow hidden to body with scrollbar compensation (desktop only)
              lockBodyScroll();
            });
          
          seenUrls.existingCount = productCount;
        }
        renderResults.seenUrls = seenUrls;
      }
    }

    function updateSearchResultsPosition() {
      var headerSection = document.querySelector('.shopify-section--header');
      var header = headerSection ? headerSection.querySelector('header') : null;
      if (header) {
        // Force reflow to ensure layout is updated
        void header.offsetHeight;
        var headerRect = header.getBoundingClientRect();
        var headerHeight = headerRect.height;
        searchResults.style.top = headerHeight + 'px';
        searchResults.style.maxHeight = 'calc(100vh - ' + headerHeight + 'px)';
        document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
        
        // Update overlay position to start below search results
        var searchOverlay = document.getElementById('HeaderSearchOverlay');
        if (searchOverlay && searchResults.getAttribute('aria-hidden') === 'false') {
          var resultsRect = searchResults.getBoundingClientRect();
          var overlayTop = resultsRect.bottom;
          searchOverlay.style.top = overlayTop + 'px';
        }
      }
    }
    
    function updateHeaderHeight() {
      var headerSection = document.querySelector('.shopify-section--header');
      var header = headerSection ? headerSection.querySelector('header') : null;
      if (header) {
        // Force multiple reflows to ensure all CSS transitions and layout updates are complete
        void header.offsetHeight;
        void header.offsetHeight;
        
        // Use getBoundingClientRect to get the actual rendered height including padding
        var headerRect = header.getBoundingClientRect();
        var headerHeight = headerRect.height;
        
        // Also check the wrapper height if it exists
        var headerWrapper = header.querySelector('.Header__Wrapper');
        if (headerWrapper) {
          var wrapperRect = headerWrapper.getBoundingClientRect();
          // Use the larger of the two to ensure we capture all padding
          headerHeight = Math.max(headerHeight, wrapperRect.height);
        }
        
        document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
        updateSearchResultsPosition();
      }
    }

    function performSearch(query) {
      if (!query || query.trim() === '') {
        resetSearch();
        return;
      }

      lastInputValue = query;
      var searchUrl = (window.routes && window.routes.searchUrl) ? window.routes.searchUrl : '/search';
      
      // Use main-search section like /search page does - it supports more than 10 results
      var baseQuery = query.trim();
      
      queryMap[query] = true;
      
      // Use main-search section which allows pagination and more results
      var url = searchUrl + '?section_id=main-search&q=' + encodeURIComponent(baseQuery + '*') + '&type=product';
      
      fetch(url, { method: 'GET', credentials: 'same-origin', cache: 'no-cache' })
        .then(function(response) {
          return response.text();
        })
        .then(function(html) {
          // Only use results if this is still the latest query
          if (lastInputValue === query && queryMap[query]) {
            // Extract products from main-search section HTML
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');
            var productCells = doc.querySelectorAll('.ProductList .Grid__Cell');
            
            if (productCells.length > 0) {
              // Build our format with first 30 products
              var cellsHTML = '';
              var count = 0;
              for (var i = 0; i < productCells.length && count < 30; i++) {
                var cell = productCells[i];
                // Add onclick to match predictive-search format
                var cellHTML = cell.outerHTML;
                if (cellHTML.indexOf('onclick=') === -1) {
                  var link = cell.querySelector('a[href*="/products/"]');
                  if (link) {
                    var productUrl = link.getAttribute('href');
                    cellHTML = cellHTML.replace(/<div class="Grid__Cell"/, '<div class="Grid__Cell" onclick="window.location.href = \'' + productUrl.replace(/'/g, "\\'") + '\'"');
                  }
                }
                cellsHTML += cellHTML;
                count++;
              }
              
              var finalHTML = '<div class="Segment"><div class="Segment__Title Segment__Title--flexed" style="display:none !important;"></div><div class="Segment__Content"><div class="Grid Grid--xl">' + cellsHTML + '</div></div></div>';
              
              updateSearchResultsPosition();
              searchResults.innerHTML = finalHTML;
            } else {
              // Fallback: show empty state
              searchResults.innerHTML = '<div class="Segment"><div class="Segment__Content"><p>No results found</p></div></div>';
            }
            
            // Add search-open class to header to remove transparent styles
            var headerSection = document.querySelector('.shopify-section--header');
            var header = headerSection ? headerSection.querySelector('header') : null;
            if (header) {
              header.classList.add('Header--search-open');
            }
            
            // Desktop: add is-active, Mobile: ensure mobile-search-active is present
            if (window.innerWidth >= 768) {
              searchWrapper.classList.add('is-active');
            } else {
              // Mobile already has mobile-search-active from icon click
              if (!searchWrapper.classList.contains('mobile-search-active')) {
                searchWrapper.classList.add('mobile-search-active');
                isMobileSearchActive = true;
              }
            }
            
            // Wait for next frame and then update height multiple times to ensure layout is complete
            requestAnimationFrame(function() {
              updateHeaderHeight();
              // Update again after a short delay to catch any delayed CSS transitions
              setTimeout(function() {
                updateHeaderHeight();
                searchResults.setAttribute('aria-hidden', 'false');
                
                // Show overlay only on desktop
                var searchOverlay = document.getElementById('HeaderSearchOverlay');
                if (searchOverlay && window.innerWidth >= 768) {
                  searchOverlay.setAttribute('aria-hidden', 'false');
                  // Position overlay below search results
                  var resultsRect = searchResults.getBoundingClientRect();
                  searchOverlay.style.top = resultsRect.bottom + 'px';
                }
                
                // Update one more time after results are set
                setTimeout(function() {
                  updateHeaderHeight();
                  // Update overlay position again after layout settles (desktop only)
                  if (searchOverlay && window.innerWidth >= 768) {
                    var resultsRect = searchResults.getBoundingClientRect();
                    searchOverlay.style.top = resultsRect.bottom + 'px';
                  }
                }, 0);
              }, 10);
              
              // Add overflow hidden to body with scrollbar compensation (desktop only)
              lockBodyScroll();
            });
            
            delete queryMap[query];
          }
        })
        .catch(function(error) {
          console.error('Search error:', error);
          delete queryMap[query];
        });
    }

    var debouncedSearch = debounce(function(event) {
      var query = event.target.value;
      updateCancelButton();
      performSearch(query);
    }, 300);

    searchInput.addEventListener('input', function(event) {
      updateCancelButton();
      debouncedSearch(event);
      
      // Update header height when typing
      if (searchInput.value.trim() !== '') {
        requestAnimationFrame(function() {
          updateHeaderHeight();
        });
      }
    });

    searchInput.addEventListener('focus', function() {
      updateSearchResultsPosition();
      
      // Add search-open class to header to remove transparent styles when input is focused
      var headerSection = document.querySelector('.shopify-section--header');
      var header = headerSection ? headerSection.querySelector('header') : null;
      if (header) {
        header.classList.add('Header--search-open');
      }
      
      // Add overflow hidden to body with scrollbar compensation (desktop only)
      lockBodyScroll();
      
      if (searchInput.value.trim() !== '') {
        // Desktop behavior
        if (window.innerWidth >= 768) {
          searchWrapper.classList.add('is-active');
        }
        // Update header height after adding is-active class
        requestAnimationFrame(function() {
          updateHeaderHeight();
        });
        if (searchResults.innerHTML.trim() !== '') {
          searchResults.setAttribute('aria-hidden', 'false');
        }
      }
      updateCancelButton();
    });

    // Cancel button click handler
    if (searchCancel) {
      searchCancel.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        resetSearch();
      });
    }

    // Close search results when clicking outside
    document.addEventListener('click', function(event) {
      // Don't close if clicking on mobile search icon
      if (mobileSearchIcon && mobileSearchIcon.contains(event.target)) {
        return;
      }
      
      if (searchWrapper && !searchWrapper.contains(event.target)) {
        resetSearch();
      }
    });

    // Close search when clicking on overlay
    var searchOverlay = document.getElementById('HeaderSearchOverlay');
    if (searchOverlay) {
      searchOverlay.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        resetSearch();
      });
    }

    // Handle form submission
    var searchForm = searchInput.closest('form');
    if (searchForm) {
      searchForm.addEventListener('submit', function(e) {
        if (searchInput.value.trim() === '') {
          e.preventDefault();
          return false;
        }
      });
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeaderSearch);
  } else {
    initHeaderSearch();
  }

  // Update position on scroll/resize if header is sticky
  window.addEventListener('scroll', function() {
    var searchResults = document.getElementById('HeaderSearchResults');
    if (searchResults && searchResults.getAttribute('aria-hidden') === 'false') {
      var header = document.querySelector('.shopify-section--header header');
      if (header) {
        var headerRect = header.getBoundingClientRect();
        var headerHeight = headerRect.height;
        searchResults.style.top = headerHeight + 'px';
        
        // Update overlay position
        var searchOverlay = document.getElementById('HeaderSearchOverlay');
        if (searchOverlay && searchOverlay.getAttribute('aria-hidden') === 'false') {
          var resultsRect = searchResults.getBoundingClientRect();
          searchOverlay.style.top = resultsRect.bottom + 'px';
        }
      }
    }
  }, { passive: true });

  window.addEventListener('resize', function() {
    var searchResults = document.getElementById('HeaderSearchResults');
    if (searchResults && searchResults.getAttribute('aria-hidden') === 'false') {
      var header = document.querySelector('.shopify-section--header header');
      if (header) {
        var headerRect = header.getBoundingClientRect();
        var headerHeight = headerRect.height;
        searchResults.style.top = headerHeight + 'px';
        searchResults.style.maxHeight = 'calc(100vh - ' + headerHeight + 'px)';
        
        // Update overlay position
        var searchOverlay = document.getElementById('HeaderSearchOverlay');
        if (searchOverlay && searchOverlay.getAttribute('aria-hidden') === 'false') {
          var resultsRect = searchResults.getBoundingClientRect();
          searchOverlay.style.top = resultsRect.bottom + 'px';
        }
      }
    }
  }, { passive: true });

  // REMOVED: Scroll-based hide/show behavior for mobile search
  // Mobile search is now toggled via the search icon button click
  // No longer using scroll to show/hide search on homepage or collection pages

})();

